import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseRoutes } from '@nts/std';
import { environment } from 'src/environments/environment';

const title = environment ? environment.appTitle : 'Application Title';
const routes: Routes = [

    // #region rotte con autenticazione
    ...BaseRoutes.getBaseAuthentictedRoutes(
        environment,
        [
            ...BaseRoutes.getEntityRoutes(
                title,
                'trackingf24data',
                () => import('./tracking-f24-data/tracking-f24-data.module').then(m => m.TrackingF24DataModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'financialoffice',
                () => import('./financial-office/financial-office.module').then(m => m.FinancialOfficeModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'chamberrightprovince',
                () => import('./chamber-right-province/chamber-right-province.module').then(m => m.ChamberRightProvinceModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'localauthority',
                () => import('./local-authority/local-authority.module').then(m => m.LocalAuthorityModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'bondloanissuer',
                () => import('./bond-loan-issuer/bond-loan-issuer.module').then(m => m.BondLoanIssuerModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'treasurytax',
                () => import('./treasury-tax/treasury-tax.module').then(m => m.TreasuryTaxModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'regiontax',
                () => import('./region-tax/region-tax.module').then(m => m.RegionTaxModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'localtaxpaymentcollector',
                () => import('./local-tax-payment-collector/local-tax-payment-collector.module').then(m => m.LocalTaxPaymentCollectorModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'localtax',
                () => import('./local-tax/local-tax.module').then(m => m.LocalTaxModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'inpssite',
                () => import('./inps-site/inps-site.module').then(m => m.InpsSiteModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'inpsregistrationnumberformat',
                () => import('./inps-registration-number-format/inps-registration-number-format.module').then(m => m.InpsRegistrationNumberFormatModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'inpstaxreason',
                () => import('./inps-tax-reason/inps-tax-reason.module').then(m => m.InpsTaxReasonModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'inailsite',
                () => import('./inail-site/inail-site.module').then(m => m.InailSiteModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'othersocialsecurityauthority',
                () => import('./other-social-security-authority/other-social-security-authority.module').then(m => m.OtherSocialSecurityAuthorityModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'othersocialsecuritysite',
                () => import('./other-social-security-site/other-social-security-site.module').then(m => m.OtherSocialSecuritySiteModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'othersocialsecurityreason',
                () => import('./other-social-security-reason/other-social-security-reason.module').then(m => m.OtherSocialSecurityReasonModule)
            ),
            ...BaseRoutes.getEntityRoutes(
                title,
                'taxcodemapping',
                () => import('./tax-code-mapping/tax-code-mapping.module').then(m => m.TaxCodeMappingModule)
            ),
            ...BaseRoutes.getDefaultRoutes(
                title,
                environment,
                true
            )
        ]
    ),
    // #endregion rotte con autenticazione

    // rotte base per la gestione degli errori
    ...BaseRoutes.getBaseErrorsRoute()

];

@NgModule({
    imports: [
        RouterModule.forRoot(routes),
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
